import WOW from 'wow.js';

const wow = new WOW({});
wow.init();

export default wow;
